import { cookie } from 'constant';
import Cookies from 'js-cookie';

const getCookieOptions = (expiresAt: number): Cookies.CookieAttributes => ({
  expires: new Date(expiresAt),
  sameSite: 'lax',
  secure: window.location.protocol === 'https:'
});

export const saveAuthSession = (
  token: string,
  encryptedProfile: string,
  sessionExpiresAtUtc: string,
  tokenExpiresAtUtc: string,
  msalAccountId?: string
) => {
  const expiresAt = new Date(sessionExpiresAtUtc).getTime();
  const tokenExpiresAt = new Date(tokenExpiresAtUtc).getTime();

  if (
    !Number.isFinite(expiresAt) ||
    expiresAt <= Date.now() ||
    !Number.isFinite(tokenExpiresAt) ||
    tokenExpiresAt <= Date.now()
  ) {
    throw new Error('Invalid session expiration received from server.');
  }

  const options = getCookieOptions(expiresAt);

  Cookies.set(cookie.token, token, options);
  Cookies.set(cookie.profile, encryptedProfile, options);
  Cookies.set(cookie.expiresAt, String(expiresAt), options);
  Cookies.set(cookie.tokenExpiresAt, String(tokenExpiresAt), options);

  if (msalAccountId) {
    Cookies.set(cookie.msalAccountId, msalAccountId, options);
  }
};

export const updateAuthToken = (token: string, tokenExpiresAtUtc: string) => {
  const expiresAt = getSessionExpiresAt();
  const tokenExpiresAt = new Date(tokenExpiresAtUtc).getTime();

  if (
    !expiresAt ||
    Date.now() >= expiresAt ||
    !Number.isFinite(tokenExpiresAt) ||
    tokenExpiresAt <= Date.now()
  ) {
    throw new Error('Cannot refresh an expired authentication session.');
  }

  const options = getCookieOptions(expiresAt);

  Cookies.set(cookie.token, token, options);
  Cookies.set(cookie.tokenExpiresAt, String(tokenExpiresAt), options);
};

export const clearAuthSession = () => {
  Cookies.remove(cookie.token);
  Cookies.remove(cookie.profile);
  Cookies.remove(cookie.expiresAt);
  Cookies.remove(cookie.tokenExpiresAt);
  Cookies.remove(cookie.msalAccountId);
};

export const getSessionExpiresAt = () => {
  const expiresAt = Number(Cookies.get(cookie.expiresAt));

  return Number.isFinite(expiresAt) ? expiresAt : null;
};

export const getTokenExpiresAt = () => {
  const expiresAt = Number(Cookies.get(cookie.tokenExpiresAt));

  return Number.isFinite(expiresAt) ? expiresAt : null;
};

export const getMsalAccountId = () => Cookies.get(cookie.msalAccountId) || null;

export const isAuthSessionValid = () => {
  const expiresAt = getSessionExpiresAt();

  return Boolean(
    Cookies.get(cookie.token) && Cookies.get(cookie.profile) && expiresAt && Date.now() < expiresAt
  );
};
